// Palm Portal (self-guided kiosk) mode state + exit PIN.
export const PORTAL_PIN = "5555";
const KEY = "soma_portal";

export const isPortalMode = () => localStorage.getItem(KEY) === "1";
export const enterPortal = () => localStorage.setItem(KEY, "1");
export const exitPortal = () => localStorage.removeItem(KEY);
